/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileUnavailable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 2h7.414L21 8.586V16h-2v-6h-6V4H7zm8 3.414V8h2.586zm-12 0L1.293 3.707l1.414-1.414 19.5 19.5-1.414 1.414L19.586 22H3zm2 2V20h12.586z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileUnavailable as FileUnavailable };
